<perfect-scrollbar class="sidebar" [config]="config">
  <nav class="sidebar-nav">
    <ul class="nav">
      <!--
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/menu/home']"><i class="fa fa-home"></i> Tesla </a>
                </li>

                <li class="divider"></li>
                -->
      <li class="nav-title">
        Menu
        <!-- {{genericVisuals.menus}} -->
      </li>
      <li class="nav-item nav-dropdown" routerLinkActive="open" *ngFor="let parent of menus">
        <a class="nav-link nav-dropdown-toggle" href="javascript:void(0);"
          ><!--<i class="fa fa-bars"></i>-->{{ parent.label }}</a
        >
        <ul class="nav-dropdown-items">
          <li class="nav-item" *ngFor="let child of parent?.submenulist" appMobileSidebarClose>
            <a class="nav-link" routerLinkActive="active" [routerLink]="['/menu/'+child.mnId]"
              >{{child.label}}
            </a>
          </li>
        </ul>
      </li>

      <!--
                Hidden nav item (with header-nav height): 
                perfect-scrollbar always hides the last if expanded
                because it doesn't take header-nav height into account
                -->
      <li id="scrollbarSpacer" class="nav-item">
        <a class="nav-link" href="javascript:void(0);" appMobileSidebarSpacerClose>S p a c e r</a>
      </li>
    </ul>
  </nav>
</perfect-scrollbar>
